import React from "react";
import { isSameDay } from "date-fns";

/**
 * Separa grupos de mensajes por fecha.
 * Muestra la fecha del día en el primer mensaje y cuando el día cambia.
 *
 * @param {object}   message       — mensaje actual
 * @param {number}   index         — posición en filteredMessages
 * @param {object[]} messagesList  — lista completa (state), usada para lookup del anterior
 * @param {Function} parseNaiveDate — de useTimezone()
 * @param {object}   classes       — CSS-in-JS de messagesListStyles
 */
export const renderDailyTimestamps = (message, index, messagesList, parseNaiveDate, classes) => {
  // ✅ CORRECCIÓN TIMEZONE: Usar parseNaiveDate del hook useTimezone para parsear correctamente
  if (index === 0) {
    const parsedDate = message.createdAt ? parseNaiveDate(message.createdAt) : null;
    const isValidDate = parsedDate && parsedDate.isValid();

    return (
      <span
        className={classes.dailyTimestamp}
        key={`timestamp-${message.id}`}
      >
        <div className={classes.dailyTimestampText}>
          {isValidDate
            ? parsedDate.format("DD/MM/YYYY")
            : "Fecha no disponible"}
        </div>
      </span>
    );
  }

  if (index < messagesList.length - 1) {
    const messageDay = message.createdAt
      ? parseNaiveDate(message.createdAt)
      : null;
    const previousMessageDay = messagesList[index - 1].createdAt
      ? parseNaiveDate(messagesList[index - 1].createdAt)
      : null;

    // ✅ VALIDACIÓN: Verificar que ambas fechas sean válidas antes de comparar y formatear
    const isValidMessageDay = messageDay && messageDay.isValid();
    const isValidPreviousDay = previousMessageDay && previousMessageDay.isValid();

    if (
      isValidMessageDay &&
      isValidPreviousDay &&
      !isSameDay(messageDay.toDate(), previousMessageDay.toDate())
    ) {
      return (
        <span
          className={classes.dailyTimestamp}
          key={`timestamp-${message.id}`}
        >
          <div className={classes.dailyTimestampText}>
            {messageDay.format("DD/MM/YYYY")}
          </div>
        </span>
      );
    }
  }
};

/**
 * Muestra "Conversa encerrada / iniciada" cuando el ticketId cambia entre mensajes consecutivos.
 *
 * @param {object}   message                 — mensaje actual
 * @param {number}   index                   — posición en filteredMessagesArray
 * @param {object[]} filteredMessagesArray    — lista filtrada para display
 * @param {Function} formatDateTime           — de useTimezone()
 * @param {object}   classes                 — CSS-in-JS de messagesListStyles
 */
export const renderNumberTicket = (message, index, filteredMessagesArray, formatDateTime, classes) => {
  // ✅ CORREGIDO: Solo mostrar si hay mensaje anterior y el ticketId cambió
  if (index > 0 && index < filteredMessagesArray.length) {
    let messageTicket = message.ticketId;
    let previousMessageTicket = filteredMessagesArray[index - 1].ticketId;

    // ✅ SOLO MOSTRAR SI EL TICKETID REALMENTE CAMBIÓ Y NO ES EL PRIMER MENSAJE
    if (messageTicket && previousMessageTicket && messageTicket !== previousMessageTicket) {
      return (
        <center key={`ticket-change-${messageTicket}-${previousMessageTicket}`}>
          <div className={classes.ticketNunberClosed}>
            Conversa encerrada:{" "}
            {filteredMessagesArray[index - 1].createdAt &&
            !isNaN(new Date(filteredMessagesArray[index - 1].createdAt).getTime())
              ? formatDateTime(filteredMessagesArray[index - 1].createdAt)
              : "Fecha no disponible"}
          </div>

          <div className={classes.ticketNunberOpen}>
            Conversa iniciada:{" "}
            {message.createdAt && !isNaN(new Date(message.createdAt).getTime())
              ? formatDateTime(message.createdAt)
              : "Fecha no disponible"}
          </div>
        </center>
      );
    }
  }
  return null; // ✅ RETORNAR null SI NO HAY CAMBIO DE TICKET
};

/**
 * Inserta un margen superior cuando la dirección del mensaje cambia
 * (fromMe ↔ !fromMe) entre dos mensajes consecutivos.
 *
 * @param {object}   message      — mensaje actual (usado solo para la key)
 * @param {number}   index        — posición en filteredMessages
 * @param {object[]} messagesList — lista completa (state) para lookup de fromMe
 */
export const renderMessageDivider = (message, index, messagesList) => {
  if (index < messagesList.length && index > 0) {
    let messageUser = messagesList[index].fromMe;
    let previousMessageUser = messagesList[index - 1].fromMe;

    if (messageUser !== previousMessageUser) {
      return (
        <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
      );
    }
  }
};
